import { render, staticRenderFns } from "./SchoolSearchAdminDashboard.vue?vue&type=template&id=78223303&"
import script from "./SchoolSearchAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./SchoolSearchAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports